import React from 'react';
import './ContactInfo.css';

function ContactInfo() {
  return (
    <div className="ContactInfo">
      <header className="ContactInfo-header">
        <h1 style={{ color: "#184758" }}>Contact Us</h1>
        <p>
          If you have any questions, support issues, or need help, 
          please feel free to contact us at <a href="mailto:wellmindappo@outlook.com" 
          style={{ color: "#f69868" }}>wellmindappo@outlook.com</a>.
        </p>
      </header>
    </div>
  );
}

export default ContactInfo;
